jQuery(function() {
  var trackingId = Cookies.get('tracking_id');
  if (trackingId) {
    jQuery("<input>").attr({
      name: "tracking_id",
      id: "tracking_id",
      type: "hidden",
      value: trackingId,
    }).appendTo("#contact-form");
  }
  jQuery("#contact-form").submit(function(e) {
    var formErrors = jQuery("#form-errors");
    var name = jQuery("#name").val().trim();
    var email = jQuery("#email").val().trim();
    var phone = jQuery("#phone").val().trim();

    formErrors.empty();
    var valid = true;
    if (name == '') {
      valid = false;
      appendToList(formErrors, 'Name is required');
    }
    if (email == '') {
      valid = false;
      appendToList(formErrors, 'Email is required');
    }
    else {
      if (email != '' && !validateEmail(email)) {
        valid = false;
        appendToList(formErrors, 'Check email address, format looks wrong');
      }
      if (phone != '' && !validatePhone(phone)) {
        valid = false;
        appendToList(formErrors, 'Check phone number, format looks wrong');
      }
    }
    if (!valid) {
      e.preventDefault();
      return false;
    }
    Cookies.remove('tracking_id');
  });
});
